<template>
	<div>
		<!-- <div class="bg-light-form text-center">
			<h1>Not implemented</h1>
			New features coming soon
		</div> -->

		<b-form>
			<b-row>
				<b-col cols="auto">
					<b-card>
						<b-form>
							<div style="margin-top: 15px">
								<label for="chartInterval">Select time Interval</label>
								<b-select
									id="chartInterval"
									size="sm"
									v-model="rfGraphForm.interval"
									:options="intervalOptions"
								>
								</b-select>
							</div>

							<div style="margin-top: 15px">
								<label for="fromDate" class="text-sm">From Date:</label>
								<b-form-input
									class="disabled-input"
									v-model="rfGraphForm.from_dt"
									size="sm"
									type="datetime-local"
									id="fromDate"
								/>

								<label for="toDate" class="text-sm">To Date:</label>
								<b-form-input
									class="disabled-input"
									v-model="rfGraphForm.to_dt"
									size="sm"
									type="datetime-local"
									id="toDate"
								/>
							</div>

							<div style="margin-top: 15px">
								<label for="chart-date">Series</label>
								<b-select id="series" size="sm" v-model="rfGraphForm.series" :options="seriesOptions">
								</b-select>
							</div>

							<div class="text-right mt-3">
								<base-button
                  data-cy="graph-tab-search-btn"
									type="primary"
									title="Search"
									size="sm"
									@click="updateGraph"
									:loading="loadingStatus"
									class="mb-3"
								>
									Update Graph
								</base-button>
							</div>
						</b-form>
						<div v-if="showErrorMessage" class="error-message mt-2" style="width: 230px">
							Error:
							{{ errorMessage }}
						</div>
					</b-card>
				</b-col>

				<b-col xl="8" md="8" sm="12">
					<div class="rf-highchart text-center">
						<div class="text-center w-100">
							<b-icon
								icon="three-dots"
								class="text-center loading-icon-style"
								animation="cylon"
								font-scale="4"
								v-if="loadingStatus"
							></b-icon>
						</div>
						<highcharts :options="chartOptions" v-if="!loadingStatus"></highcharts>
					</div>
				</b-col>
			</b-row>
		</b-form>
	</div>
</template>

<script>
// import rfService from "../../../../common/api-services/rf-dashboard-service";
import rfDashboardService from "../../../../common/api-services/rf-dashboard-service";
//import rfDashboardServices from '../../../../common/api-services/rf-dashboard-service'
import {Chart} from "highcharts-vue";
import ToastVue from "../../../Components/Toast";
import moment from "moment";

export default {
	name: "rf-Graph",
	components: {
		ToastVue,
		Highcharts: Chart,
	},
	data() {
		return {
			rfGraphForm: {
				from_dt: moment().subtract(7, "days").format("YYYY-MM-DD HH:mm:ss"),
				to_dt: moment().format("YYYY-MM-DD HH:mm:ss"),
				result_type: "graph",
				series: "called-party.cause-description",
				interval: "1m",
			},
			intervalLookup: {
				"1 Minute": "1m",
				"15 Minutes": "15m",
				"30 Minutes": "30m",
				"60 Minutes": "60m",
				"1 Hour": "1h",
				"12 Hours": "12h",
				"1 Day": "1d",
				// "1 Week": "1w",
				// "1 Month": "1M",
				// "1 Quarter": "1q",
				// "1 Year": "1y",
			},
			seriesOptions: [
				"Called_Party_Address",
				"Subscription_ID",
				"SIP-Request-Timestamp",
				"IMS_Charging_Identifier",
				"Event_Type",
				"fingerprint",
				"User_Session_ID",
				"Calling_Party_Address",
				"Accounting_Record_Type",
				"utran-cell-id-3gpp",
				"called-party.cause-description",
			],
			loadingStatus: false,
			showErrorMessage: false,
			errorMessage: "",

			chartOptions: {
				chart: {
					zoomType: "x",
				},
				title: {
					text: "Messages",
					style: {
						color: "#000000",
					},
				},
				xAxis: {
					type: "datetime",
					title: {
						text: "",
						style: {
							color: "#000000",
							fontSize: "14px",
						},
					},
				},
				yAxis: {
					title: {
						text: "",
						style: {
							color: "#000000",
							fontSize: "14px",
						},
					},
				},
				legend: {
					layout: "vertical",
					align: "right",
					verticalAlign: "middle",
					itemStyle: {
						color: "#000000",
					},
				},
				plotOptions: {
					series: {
						label: {
							connectorAllowed: false,
						},
						marker: {
							enabled: false,
						},
					},
					colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c"],
				},
				series: [],
			},
		};
	},
	mounted() {
		//this.rfFunc();
	},
	computed: {
		intervalOptions() {
			return Object.keys(this.intervalLookup).map(label => ({value: this.intervalLookup[label], text: label}));
		},
	},
	methods: {
		rfFunc() {
			this.loadingStatus = true;
			this.chartOptions.title.text = "Loading...";
			let client = process.env.VUE_APP_CLIENT;
			let rfQueryData = {
				index: `${client}-rf-*`,
				from_dt: this.rfGraphForm.from_dt,
				to_dt: this.rfGraphForm.to_dt,
				result_type:
					this.rfGraphForm.series === "called-party.cause-description"
						? "graph2"
						: this.rfGraphForm.result_type,
				series: this.rfGraphForm.series,
				interval: this.rfGraphForm.interval,
			};
			// console.log(rfQueryData);
			rfDashboardService
				.getRfQuery(rfQueryData)
				.then(res => {
					if (res.hasOwnProperty("aggregations")) {
						// this.chartOptions.yAxis.title.text = this.rfGraphForm.series;
						this.chartOptions.title.text = "Messages";
						this.processResults(res.aggregations[0].buckets, this.rfGraphForm.series);
					}
				})
				.catch(e => {
					if (process.env.NODE_ENV === "dev") console.error(e);
					this.chartOptions.series = [];
					this.chartOptions.title.text = "No Messages in this Date Range for the selected Interval.";
				})
				.finally(() => {
					this.loadingStatus = false;
				});
		},

		async updateGraph() {
			if (this.showErrorMessage) {
				this.$toast.error({
					component: ToastVue,
					props: {
						description: "Error - Please select valid date range",
					},
				});

				return false;
			}
			this.rfFunc();
		},

		processResults(data, series) {
			let arr = [];
			let browserDate = new Date();
			let timeZoneOffset = browserDate.getTimezoneOffset() * 60 * 1000;
			// this.chartOptions.xAxis.title.text = `@timestamp per ${this.rfGraphForm.interval}`;
			try {
				if (series === "called-party.cause-description") {
					const busy_here = data.find(item => item.key === "Busy Here");
					if (busy_here) {
						arr.push({
							name: "Busy Here",
							color: "#AED2FF",
							data: busy_here[1].buckets.map(item => [
								new Date(item["key_as_string"]) - timeZoneOffset,
								Number.parseInt(item["doc_count"]),
							]),
						});
					}
					const request_timeout = data.find(item => item.key === "Request Timeout");
					if (request_timeout) {
						arr.push({
							name: "Request Timeout",
							color: "#45FFCA",
							data: request_timeout[1].buckets.map(item => [
								new Date(item["key_as_string"]) - timeZoneOffset,
								Number.parseInt(item["doc_count"]),
							]),
						});
					}
					const service_unavailable = data.find(item => item.key === "Service Unavailable");
					if (service_unavailable) {
						arr.push({
							name: "Service Unavailable",
							color: "#FF3FA4",
							data: service_unavailable[1].buckets.map(item => [
								new Date(item["key_as_string"]) - timeZoneOffset,
								Number.parseInt(item["doc_count"]),
							]),
						});
					}
				} else {
          if (data[0]) {
            data = data[0][1].buckets;
          }
					arr.push({
						name: "Messages",
						data: data.map(item => {
							return [
								new Date(item["key_as_string"]) - timeZoneOffset,
								Number.parseInt(item["doc_count"]),
							];
						}),
					});
				}
				// console.log(arr);
				this.chartOptions.series = arr;
			} catch (error) {
				console.error(error);
				arr = [];
			}
		},

		validateDateRange() {
			const selectedInterval = this.rfGraphForm.interval;
			const fromDt = new Date(this.rfGraphForm.from_dt);
			const toDt = new Date(this.rfGraphForm.to_dt);

			// Calculate the difference in milliseconds based on the selected interval
			const intervalInMilliseconds = this.getIntervalInMilliseconds(selectedInterval);
			const difference = toDt - fromDt;

			// Check if toDate is greater than the current date and time
			const currentDate = new Date();
			const isToDtGreaterThanCurrent = toDt > currentDate;

			if (difference < intervalInMilliseconds) {
				this.showErrorMessage = true;
				this.errorMessage = "Date range must be greater than the selected interval.";
			} else if (isToDtGreaterThanCurrent) {
				this.showErrorMessage = true;
				this.errorMessage = "To Date must not be greater than the present date.";
			} else {
				this.showErrorMessage = false;
			}
			this.rfGraphForm.from_dt = moment(this.rfGraphForm.from_dt).format("YYYY-MM-DD HH:mm:ss");
			this.rfGraphForm.to_dt = moment(this.rfGraphForm.to_dt).format("YYYY-MM-DD HH:mm:ss");
		},

		getIntervalInMilliseconds(interval) {
			const intervalMappings = {
				"1m": 1 * 60 * 1000,
				"15m": 15 * 60 * 1000,
				"30m": 30 * 60 * 1000,
				"60m": 60 * 60 * 1000,
				"1h": 60 * 60 * 1000,
				"12h": 12 * 60 * 60 * 1000,
				"1d": 24 * 60 * 60 * 1000,
				"1w": 7 * 24 * 60 * 60 * 1000,
				"1M": 30 * 24 * 60 * 60 * 1000,
				"1q": 3 * 30 * 24 * 60 * 60 * 1000,
				"1y": 365 * 24 * 60 * 60 * 1000,
			};

			return intervalMappings[interval] || 0;
		},
	},
	watch: {
		"rfGraphForm.interval": "validateDateRange",
		"rfGraphForm.from_dt": "validateDateRange",
		"rfGraphForm.to_dt": "validateDateRange",
	},
};
</script>

<style scoped>
.rf-highchart {
	border: 10px solid #dee2e6;
	background-color: #dee2e6;
	min-height: 400px;
}

.loading-icon-style {
	position: fixed;
	height: 40%;
}

.error-message {
	color: red;
	margin-top: 10px;
}
</style>
